import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-slate-700/60 bg-slate-900 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1yeb4ckorj8qr">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1anxn7p7puuay">
        <SectionHeading id="bonus-title" data-id="element-20" data-mp="1aop4rw4hari8">The {totalBonuses} <span className="text-amber-400" data-id="element-21" data-mp="15pw1ewiwogvs">Exclusive Bonuses</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-slate-700 bg-slate-950 shadow-lg shadow-black/30" data-id="element-22" data-mp="1jgiqdwyv6seo">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-slate-800 p-5 last:border-b-0 sm:p-6" data-id="element-23" data-mp="r07yxryznc6h" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-blue-300/30 bg-slate-900 text-blue-300" data-id="element-24" data-mp="2jixs8swx771d">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-25" data-mp="1qt8my3d6gkty" />
                </span>
                <div className="min-w-0 flex-1" data-id="element-26" data-mp="1qvldv60wy5j5">
                  <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1" data-id="element-27" data-mp="1vtd47vlwtjl8">
                    <p className="text-xs font-bold uppercase tracking-[.14em] text-amber-400" data-id="element-28" data-mp="20r54bcwpkc0i">Bonus {bonus.number}</p>
                    <p className="text-xs font-bold text-slate-400" data-id="element-29" data-mp="25r9hasyeqolz">
                      Value: <span className="line-through decoration-amber-400 decoration-2" data-id="element-30" data-mp="3c7d0mwljqr3q">{bonus.value}</span>{' '}
                      <span className="text-amber-400" data-id="element-31" data-mp="3h4bude1asw1e">FREE</span>
                    </p>
                  </div>
                  <h3 className="mt-1 text-lg font-extrabold uppercase leading-tight text-white" data-id="element-32" data-mp="1h1u4rqquva3k">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-300" data-id="element-33" data-mp="1c42boteh5hxs">{bonus.description}</p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-amber-400 bg-slate-950 px-6 py-6 text-center shadow-lg shadow-black/40 sm:flex-row sm:text-left" data-id="element-34" data-mp="1m3tav8dzcl47">
          <div data-id="element-35" data-mp="tf43wsq8tlkj">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-slate-300" data-id="element-36" data-mp="tfnnsezgek17">Value of all {totalBonuses} bonuses</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-slate-300 line-through decoration-amber-400 decoration-2" data-id="element-37" data-mp="12eivxwm26475">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-38" data-mp="emk7eaxlmcc2">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-slate-300" data-id="element-39" data-mp="ao4ke71ip3yn">Your price today</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-amber-400" data-id="element-40" data-mp="id33ki2er6w">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-41" data-mp="5bo2j0kjs5os" /> FREE
            </p>
          </div>
        </div>
      </div>
    </section>;
}